// Modal öffnen
  function openCookieModal() {
    const modal = document.getElementById('cookie-banner-modal-container');
    if (modal) {
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      
      // Lade Privacy Policy Content
      loadPrivacyContent();
    }
  }

  // Privacy Policy Content laden
  function loadPrivacyContent() {
    const contentDiv = document.getElementById('cookie-modal-text-container');
    
    if (!contentDiv) {
      console.error('Cookie modal container not found');
      return;
    }
    
    contentDiv.innerHTML = '<p style="text-align: center;">' + ((window.nrI18n && window.nrI18n.privacyLoading) || 'Lädt Datenschutzerklärung...') + '</p>';
    
    fetch('https://trackcard.eu/policies/privacy-policy')
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Suche nach dem spezifischen Shopify Privacy Policy Container
        const policyBody = doc.querySelector('.shopify-policy__body');
        
        if (policyBody) {
          contentDiv.innerHTML = policyBody.innerHTML;
        } else {
          // Fallback zu anderen Selektoren
          const policyContent = doc.querySelector('.shopify-policy__container, .rte, main');
          if (policyContent) {
            contentDiv.innerHTML = policyContent.innerHTML;
          } else {
            contentDiv.innerHTML = '<p>' + ((window.nrI18n && window.nrI18n.privacyLoadError) || 'Datenschutzerklärung konnte nicht geladen werden.') + '</p>';
          }
        }
      })
      .catch(error => {
        console.error('Error loading privacy policy:', error);
        contentDiv.innerHTML = '<p style="color: red;">' + ((window.nrI18n && window.nrI18n.privacyLoadErrorRetry) || 'Fehler beim Laden der Datenschutzerklärung. Bitte versuchen Sie es später erneut.') + '</p>';
      });
  }

  // Modal schließen
  function closeCookieModal() {
    const modal = document.getElementById('cookie-banner-modal-container');
    if (modal) {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = ''; // Erlaubt wieder Scrollen
    }
  }

  // Modal schließen beim Klick auf den Hintergrund
  document.getElementById('cookie-banner-modal-container')?.addEventListener('click', function(e) {
    if (e.target === this) {
      closeCookieModal();
    }
  });

  // Modal schließen mit ESC-Taste
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCookieModal();
    }
  });

  // Pandectes Link abfangen - wartet bis Banner geladen ist
  function attachPrivacyLinkHandler() {
    const privacyLink = document.querySelector('a.cc-link[href="/policies/privacy-policy"], a.cc-link[href*="/policies/privacy-policy"]');
    
    if (privacyLink && !privacyLink.dataset.modalAttached) {
      privacyLink.dataset.modalAttached = 'true';
      privacyLink.addEventListener('click', function(e) {
        e.preventDefault();
        openCookieModal();
      });
      return true;
    }
    return false;
  }

  // Versuche sofort
  document.addEventListener('DOMContentLoaded', function() {
    attachPrivacyLinkHandler();
  });

  // Beobachte DOM-Änderungen für dynamisch geladenes Pandectes Banner
  const observer = new MutationObserver(function(mutations) {
    if (attachPrivacyLinkHandler()) {
      observer.disconnect(); // Stoppe Beobachtung wenn Link gefunden
    }
  });

  // Starte Beobachtung
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Fallback: Event Delegation für dynamische Elemente
  document.addEventListener('click', function(e) {
    if (e.target.matches('a.cc-link[href="/policies/privacy-policy"], a.cc-link[href*="/policies/privacy-policy"]')) {
      e.preventDefault();
      openCookieModal();
    }
  });